module.exports = {"workflows":{"ask-to-archive-picklist":{"title":"Are you sure?","content":"Please confirm that you want to archive picklist:<br><strong>{{picklist_name}}</strong>","cancel":"Cancel","confirm":"Archive"},"ask-to-delete-picklist":{"title":"Are you sure?","content":"Please confirm that you want to permanently delete picklist: <strong>{{picklist_name}}</strong>","cancel":"Cancel","confirm":"Archive"}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/picklists.json
// module id = 2402
// module chunks = 1